import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { FiX } from 'react-icons/fi';
import './ImageLightbox.css';

export default function ImageLightbox({ open, src, alt = '', onClose }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  if (!open || !src) return null;

  return createPortal(
    <div className="ui-lightbox" role="dialog" aria-modal="true" aria-label="Image preview">
      <div className="ui-lightbox__backdrop" onClick={onClose} />
      <button
        type="button"
        className="ui-lightbox__close"
        onClick={onClose}
        aria-label="Close"
      >
        <FiX aria-hidden />
      </button>
      <img
        className="ui-lightbox__img"
        src={src}
        alt={alt}
        onClick={(e) => e.stopPropagation()}
      />
    </div>,
    document.body
  );
}
